export default __webpack_public_path__ + "static/137-01072732469f0bde3a5073b6268b19a8.gif";